import Controler from "../common/control";
import React, { useEffect, useState, useMemo } from "react";
import { Formik, Form } from "formik";
import { connect, useSelector } from "react-redux";
import { getSchoolFormData, postSchoolIdp } from "../../../store/slices/school/index";
import "../../assets/css/idp-medical.css";
import { fetchUser } from "../../../store/slices/user/index";
import Loader from "../common/loader";
import ButtonLoader from "../common/buttonLoader";
import ThankYou from "../common/thankYou";

const randomNum = () => {
  const d = new Date();
  const ms = d.getMilliseconds();
  return ms
}
const IdpCollegeForms = (props) => {
  const [educationLevel, setEducationLevel] = useState(null);
  const [stream, setStream] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [destination, setDestination] = useState(null);


  useEffect(() => {
    props.dispatch(fetchUser());
  }, []);

  useEffect(() => {
    if (props.user?.data) {
      props.dispatch(
        getSchoolFormData({ uid: props.user?.data?.id, ms: randomNum() })
      );
      setDestination(
        window.location?.search
          ? window.location?.search.replace("?destination=", "")
          : "https://www.careers360.com"
      );
    }
  }, [props.user?.data]);

  useEffect(() => {
    const gotToHomePage = window.location?.origin;
    if (props?.isUser?.user_error === "User Not Authenticated" && !!destination)
      window.location.href = destination;
    else if (props?.isUser?.user_error === "User Not Authenticated" && !destination)
      window.location.href = gotToHomePage;
  }, [props?.isUser, destination, props.idpData]);

  // ------------------- Static Configs -------------------
  const DATA_9_10 = {
    fieldsOfStudy: [
      "PCM",
      "PCB",
      "Commerce",
      "Humanities/ Arts",
      "Not Decided Yet",
    ],
    exams: ["School Exams", "Olympiads", "SAT", "JEE/ NEET/ CLAT/ CUET", "Others"],
    yesNo: ["Yes", "No"],
    satDates: [
      "Dec 2025",
      "March 2026",
      "May 2026",
      "June 2026",
      "August 2026",
    ],
    jeeOptions: ["JEE", "NEET", "CLAT", "CUET"],
  };

  const DATA_11_PCM = {
    fieldsOfStudy: [
      "B.Tech/ B.Arch",
      "Degree Course",
      "B.A LLB",
      "B.Des (Design)",
      "Not Decided Yet",
    ],
    exams: ["JEE Main", "CLAT", "NIFT/ NID", "CUET", "None of the above"],
    yesNo: ["Yes", "No"],
  };

  const DATA_11_PCB = {
    fieldsOfStudy: ["MBBS", "BDS", "B.Sc Paramedical", "B.Sc Nursing", "Ayush"],
    exams: ["NEET UG", "AIIMS Nursing", "State Level Nursing", "CUET"],
    yesNo: ["Yes", "No"],
  };

  // ------------------- Initialize Form -------------------
  useEffect(() => {
    if (props?.idpData?.admission_preference_status === 2) {
      setIsSubmitted(true)
      setTimeout(() => {
        window.location.search?.includes('destination=http') ? window.location.href = destination : window.location.href = 'https://www.careers360.com';
      }, 5000)
    }
    if (props.idpData?.idp_form_id == 0 || (props.idpData && ![9, 10, 11].includes(props.idpData?.education_level))) {
      window.location.search?.includes('destination=http') ? window.location.href = destination : window.location.href = 'https://www.careers360.com';
    }
    if (props.idpData?.education_level == 11 && !['pcm', 'pcb'].includes(props.idpData.aspiring_stream)) {
      window.location.search?.includes('destination=http') ? window.location.href = destination : window.location.href = 'https://www.careers360.com';
    }
    if (props?.idpData?.idp_form_id && !['school_idp'].includes(props?.idpData?.idp_type)) {
      window.location.search?.includes('destination=http') ? window.location.href = destination : window.location.href = 'https://www.careers360.com';
    }
    if (props.idpData?.education_level) {
      setEducationLevel(props.idpData.education_level);
      setStream(props.idpData?.aspiring_stream || null);
      setIsLoading(false);
    }
  }, [props.idpData]);

  const flowType = useMemo(() => {
    if (educationLevel === 9 || educationLevel === 10) return "A";
    if (educationLevel === 11 && stream === "pcm") return "B";
    if (educationLevel === 11 && stream === "pcb") return "C";
    return null;
  }, [educationLevel, stream]);

  // ------------------- Handle Changes -------------------
  const handleChange = (e, setFieldValue) => {
    const { name, value } = e.target;
    setFieldValue(name, value);
  };

  // Special handler for multi-select Q2 (field_exams_targeted) in 9/10
  const handleExamMultiChange = (e, setFieldValue, values) => {
    const { checked, value, name } = e.target;
    const current = Array.isArray(values[name]) ? values[name] : [];
    let newArr;

    if (checked) {
      newArr = [...current, value];
    } else {
      newArr = current.filter((v) => v !== value);
    }

    // Deduplicate just in case
    newArr = [...new Set(newArr)];

    // Reset SAT dependent fields if SAT is no longer selected
    if (!newArr.includes("SAT")) {
      setFieldValue("exam_dates", "");
      setFieldValue("field_personalized_sat", "");
    }

    // Reset JEE/NEET/CLAT/CUET dependent fields if that option is no longer selected
    if (!newArr.includes("JEE/ NEET/ CLAT/ CUET")) {
      setFieldValue("exams", "");
      setFieldValue("field_coaching", "");
    }

    setFieldValue(name, newArr);
  };

  // ------------------- Validation -------------------
  const isFormComplete = (values) => {
    if (!values.field_of_study || !values.field_personalized
    ) {
      return false;
    }

    // Q2 required for all flows
    if (Array.isArray(values.field_exams_targeted) && values.field_exams_targeted.length === 0) {
      return false;
    }

    if (flowType === "A") {
      const targets = values.field_exams_targeted || [];
      if (targets.includes("SAT")) {
        if (!values.exam_dates || !values.field_personalized_sat) return false;
      }
      if (targets.includes("JEE/ NEET/ CLAT/ CUET")) {
        if (!values.exams || !values.field_coaching) return false;
      }
    }

    if (flowType === "B" || flowType === "C") {
      if (!values.field_coaching) return false;
    }

    return true;
  };

  // ------------------- Submission -------------------
  const onSubmit = async (values) => {
    setSubmitLoader(true);

    let examsTargeted = [];
    examsTargeted = values.field_exams_targeted;
    examsTargeted = examsTargeted.map(v => v === "JEE/ NEET/ CLAT/ CUET" ? values.exams : v);

    const hasSAT = examsTargeted.includes("SAT");

    const payload = {
      user_id: props.user?.data?.id,
      current_class: educationLevel,
      stream,
      field_of_study: values.field_of_study,
      exams_targeted: examsTargeted,
      personalized_support: values.field_personalized === "Yes" || false,
      coaching_support: values.field_coaching === "Yes" || false,
      sat_exam_dates: hasSAT ? values.exam_dates || "" : "",
      sat_personalized_support: hasSAT ? values.field_personalized_sat === "Yes" : false,
    };

    try {
      await props.dispatch(postSchoolIdp(payload));
      setIsSubmitted(true);
      setTimeout(() => {
        window.location.search?.includes('destination=http') ? window.location.href = destination : window.location.href = 'https://www.careers360.com';
      }, 3000)
      // console.log(".......post data", payload);
    } catch (err) {
      console.error("IDP Submit Error:", err);
    } finally {
      setSubmitLoader(false);
    }
  };

  // ------------------- Render -------------------
  if (isSubmitted)
    return (
      <ThankYou
        destinationUrl={destination}
        thankYouImg={"thankyou-school.png"}
      />
    );

  if (isLoading) return <Loader />;

  const data =
    flowType === "A"
      ? DATA_9_10
      : flowType === "B"
        ? DATA_11_PCM
        : flowType === "C"
          ? DATA_11_PCB
          : null;

  if (!data) return null;

  return (
    <Formik
      initialValues={{
        field_exams_targeted: [],
      }}
      enableReinitialize
      onSubmit={onSubmit}
      validate={() => ({})}
    >
      {({ values, setFieldValue }) => (
        <Form>
          {/* --- Universal Questions --- */}
          <div className="idp_medical_card radio_with_button field_study">
            <Controler
              control="radio"
              handleChange={(e) => handleChange(e, setFieldValue)}
              isMandatory
              options={data.fieldsOfStudy.map((n) => ({ name: n, id: n }))}
              name="field_of_study"
              questionName="Which field of study are you most interested in pursuing?"
            />
          </div>

          <div className="idp_medical_card radio_with_button field_study">
            <Controler
              control="checkboxGroup"
              handleChange={(e) =>
                handleExamMultiChange(e, setFieldValue, values)
              }
              isMandatory
              options={data.exams.map((n) => ({ name: n, id: n }))}
              name="field_exams_targeted"
              questionName="Which exams are you currently preparing for or planning to target?"
            />
          </div>

          <div className="idp_medical_card field_study">
            <Controler
              control="radio"
              handleChange={(e) => handleChange(e, setFieldValue)}
              isMandatory
              options={data.yesNo.map((n) => ({ name: n, id: n }))}
              name="field_personalized"
              questionName="Are you looking for personalized (one-on-one) academic support or tuition for school subjects?"
            />
          </div>

          {/* --- Conditional Sections (Only for Class 9–10) --- */}
          {flowType === "A" &&
            values.field_exams_targeted?.includes("SAT") && (
              <>
                <div className="idp_medical_card field_study">
                  <Controler
                    control="select"
                    handleChange={(e) => handleChange(e, setFieldValue)}
                    isMandatory
                    options={data.satDates.map((n) => ({ name: n, id: n }))}
                    name="exam_dates"
                    questionName="Which SAT are you appearing for?"
                  />
                </div>
                <div className="idp_medical_card field_study">
                  <Controler
                    control="radio"
                    handleChange={(e) => handleChange(e, setFieldValue)}
                    isMandatory
                    options={data.yesNo.map((n) => ({ name: n, id: n }))}
                    name="field_personalized_sat"
                    questionName="Are you seeking 1-on-1 online support for SAT?"
                  />
                </div>
              </>
            )}

          {flowType === "A" &&
            values.field_exams_targeted?.includes(
              "JEE/ NEET/ CLAT/ CUET"
            ) && (
              <>
                <div className="idp_medical_card radio_with_button field_study">
                  <Controler
                    control="radio"
                    handleChange={(e) => handleChange(e, setFieldValue)}
                    isMandatory
                    options={data.jeeOptions.map((n) => ({ name: n, id: n }))}
                    name="exams"
                    questionName="Which exam are you targeting for?"
                  />
                </div>
                <div className="idp_medical_card field_study">
                  <Controler
                    control="radio"
                    handleChange={(e) => handleChange(e, setFieldValue)}
                    isMandatory
                    options={data.yesNo.map((n) => ({ name: n, id: n }))}
                    name="field_coaching"
                    questionName="Are you seeking coaching support?"
                  />
                </div>
              </>
            )}

          {(flowType === "B" || flowType === "C") && (
            <div className="idp_medical_card field_study">
              <Controler
                control="radio"
                handleChange={(e) => handleChange(e, setFieldValue)}
                isMandatory
                options={data.yesNo.map((n) => ({ name: n, id: n }))}
                name="field_coaching"
                questionName="Are you seeking coaching support for entrance exam preparation?"
              />
            </div>
          )}

          <div className="user_guide">
            This is a quick form designed to understand your needs and help you
            in your education journey and get into the right college.
          </div>

          <div className="idp_medicine_btn_Submit">
            {submitLoader ? (
              <ButtonLoader />
            ) : (
              <input
                type="submit"
                className="action-button btn"
                disabled={!isFormComplete(values)}
                value="Submit your preferences"
              />
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = (state) => ({
  user: state.userData?.user,
  isUser: state.userData,
  idpData: state?.idpSchool?.schoolIdpSuccess?.data,
});

export default connect(mapStateToProps)(IdpCollegeForms);
